import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  CircularProgress,
  Box,
  DialogContentText,
} from "@mui/material";

const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmText,
  cancelText,
  confirmColor = "error",
  loading = false,
  warningMessage,
  confirmationPromptMessage,
  buttonText,
  contentText,
  confirmButtonText,
  cancelButtonText,
}) => {
  const effectiveTitle = title || "Confirm Action";
  const effectiveDescription = description || warningMessage || contentText || confirmationPromptMessage || "Are you sure you want to proceed?";
  const effectiveConfirmText = confirmText || confirmButtonText || buttonText || "Confirm";
  const effectiveCancelText = cancelText || cancelButtonText || "Cancel";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          // padding: { xs: "8px", md: "14px" },
          background: "#fff",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontSize: { xs: "16px", lg: "18px" },
          color: "#303f9f",
          fontWeight: "bold",
          textAlign: "center",
          paddingBottom: "12px",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        {effectiveTitle}
      </DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "20px" }}
      >
        <DialogContentText sx={{ textAlign: "center", fontSize: { xs: "14px", lg: "16px" }, mb: confirmationPromptMessage ? 1 : 0 }}>
          {effectiveDescription}
        </DialogContentText>
        {confirmationPromptMessage && (
          <Typography variant="body2" color="textSecondary" textAlign="center" sx={{ fontSize: { xs: "13px", lg: "14px" } }}>
            {confirmationPromptMessage}
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: "flex-end", marginTop: 2, marginRight: 2, marginBottom: 2 }}>
        <Button
          onClick={onClose}
          color="error"
          variant="outlined"
          sx={{ borderRadius: "24px", padding: "8px 24px", textTransform: "none", fontWeight: "bold" }}
        >
          {effectiveCancelText}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color={confirmColor}
          disabled={loading}
          sx={{ borderRadius: "24px", padding: "8px 24px", textTransform: "none", fontWeight: "bold" }}
        >
          {loading ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <CircularProgress size={18} sx={{ color: "#a9a9a9" }} />
              <Box>Processing...</Box>
            </Box>
          ) : (
            effectiveConfirmText
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;